export type LoadingStatus = keyof typeof LOADING_STATUSES;

export type LoadingState = {
  status: LoadingStatus;
};

export type TLoadingProp = {
  inProgress: boolean;
  isLoaded: boolean;
  isError: boolean;
};

export const LOADING_STATUSES: any = {
  none: "none",
  loading: "loading",
  loaded: "loaded",
  failed: "failed",
};

export const DEFAULT_LOADING_STATUS: LoadingStatus = LOADING_STATUSES.none;

export const LOADING_STATES: {
  [key: string]: LoadingState;
} = {
  default: {
    status: DEFAULT_LOADING_STATUS,
  },
  loading: {
    status: LOADING_STATUSES.loading,
  },
  loaded: {
    status: LOADING_STATUSES.loaded,
  },
  failed: {
    status: LOADING_STATUSES.failed,
  },
};

export const DEFAULT_LOADING_PROPS: TLoadingProp = {
  inProgress: false,
  isLoaded: true,
  isError: false,
};
